<template>
  <v-dialog lazy v-model="opened" max-width="600px">
    <v-btn
      flat
      fab
      :color="src ? 'success' : 'warning'"
      slot="activator"
    >
      <v-icon>mdi-file-image</v-icon>
    </v-btn>

    <!-- Cover Image Upload -->
    <v-card dark>
      <v-card-title class="title">
        Upload a new Cover Image
      </v-card-title>
      <v-img height="256px" :src="image && preview ? preview : src">
        <input type="file" name="file" ref="file" @change="setFile" style="display: none;" />
      </v-img>
      <v-card-actions>
        <v-btn @click.native="$refs.file.click()">
          Choose image
        </v-btn>
        <v-spacer />
        <v-btn flat @click="opened = false">
          cancel
        </v-btn>
        <v-btn
          :disabled="!image"
          @click="submit"
          :loading="sending"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Vue Component
export default {
  props: { src: String, path: String },
  data() {
    return {
      opened: false,
      image: null,
      preview: null,
      sending: false,
    }
  },
  methods: {
    setFile() {
      this.image = this.$refs.file.files[0]
      const reader = new FileReader()
      reader.addEventListener('load', () => (this.preview = reader.result), false)
      if (this.image) reader.readAsDataURL(this.image)
    },
    submit() {
      if (this.image) {
        this.sending = true
        let formData = new FormData()
        formData.append('cover_image', this.image)
        this.$http
          .post(this.path, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(() => {
            this.sending = false
            this.$emit('success')
            this.opened = false
          })
      }
    },
  },
}
</script>
